export const FETCH_COUNCILS = "FETCH_COUNCILS";
export const FETCH_YEARS = "FETCH_YEARS";

export const SET_COUNCILS = "SET_COUNCILS";

export const NONE = ""
export const JUMPTO = "JUMPTO"
export const COUNCILSAYS = "COUNCILSAYS"
export const LEARNMORE = "LEARNMORE"


// WEBPACK FOOTER //
// ./src/constants/ActionTypes.ts